import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { routeMap } from 'routeMap';
import { useAuthWrapperContext } from 'toolbox/src/components/AuthWrapper/AuthWrapper';

export default function AuthenticatedOnlyRoute({ component: C, ...rest }) {
  const { status } = useAuthWrapperContext();
  const isAuthenticated = status === 'loggedIn' || false;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <C {...props} />
        ) : (
          <Redirect
            to={routeMap.authenticatorRoot(
              props.location.pathname !== '/home'
                ? {
                    search: {
                      returnTo: `${props.location.pathname}${props.location.search}`,
                    },
                  }
                : undefined,
            )}
          />
        )
      }
    />
  );
}
